import { ActionContext } from 'vuex'
import apiCatalogue from '@/api/catalogue'
import apiMeta from '@/api/meta'
import apiFluxBuilder from '@/api/fluxBuilder'
import util from '@/utils/classToObject'
import actionsTypes from '@/store/all-action-types'
import types from './all-mutation-types'
import { IRootState, emptyAction, actionEnsure, payloadAction } from '@/store'
import { ICatalogueState } from './state'
import { buildStateItem } from '@/models/alo/StateItem'
import { AloMeta } from '@/models/alo/AloMeta'
import { AloFluxBuilder } from '@/models/alo/AloFluxBuilder'

export class CatalogueAction {
    public [types.CATALOGUE_MARQUE_REQUEST](context: ActionContext<ICatalogueState, IRootState>) {
        return emptyAction(context,types.CATALOGUE_MARQUE_REQUEST,types.CATALOGUE_MARQUE_SUCCESS,types.CATALOGUE_MARQUE_ERROR,apiCatalogue.getCatalogMarque)
    } 

    public [types.CATALOGUE_MARQUE_ENSURE](context: ActionContext<ICatalogueState, IRootState>) {
        return actionEnsure(context,types.CATALOGUE_MARQUE_REQUEST,context.state.marquesList)
    }

    public [types.CATALOGUE_REFERENCE_REQUEST](context: ActionContext<ICatalogueState, IRootState>) {
        return emptyAction(context,types.CATALOGUE_REFERENCE_REQUEST,types.CATALOGUE_REFERENCE_SUCCESS,types.CATALOGUE_REFERENCE_ERROR,apiCatalogue.getCatalogReference)
    }

    public [types.CATALOGUE_REFERENCE_ENSURE](context: ActionContext<ICatalogueState, IRootState>) {
        return actionEnsure(context,types.CATALOGUE_REFERENCE_REQUEST,context.state.disposList)
    }

    public [types.CATALOGUE_TREE_REQUEST](context: ActionContext<ICatalogueState, IRootState>) {
        return emptyAction(context,types.CATALOGUE_TREE_REQUEST,types.CATALOGUE_TREE_SUCCESS,types.CATALOGUE_TREE_ERROR,apiCatalogue.getCatalogTree)
    }

    public [types.CATALOGUE_TREE_ENSURE](context: ActionContext<ICatalogueState, IRootState>) {
        return actionEnsure(context,types.CATALOGUE_TREE_REQUEST,context.state.universList)
    }

    public [types.CATALOGUE_META_REQUEST](context: ActionContext<ICatalogueState, IRootState>) {
        return emptyAction(context,types.CATALOGUE_META_REQUEST,types.CATALOGUE_META_SUCCESS,types.CATALOGUE_META_ERROR,apiMeta.getAllMeta)    
    }

    public [types.CATALOGUE_META_ENSURE](context: ActionContext<ICatalogueState, IRootState>) {
        return actionEnsure(context,types.CATALOGUE_META_REQUEST,context.state.metasList)    
    }

    public [types.CATALOGUE_META_DETAIL_REQUEST](context: ActionContext<ICatalogueState, IRootState>,id:number) {
        return payloadAction(context,types.CATALOGUE_META_DETAIL_REQUEST,types.CATALOGUE_META_DETAIL_SUCCESS,types.CATALOGUE_META_DETAIL_ERROR,apiMeta.getMeta,id)
    }

    public [types.CATALOGUE_META_DETAIL_ENSURE](context: ActionContext<ICatalogueState, IRootState>,id:number) {
        //Hack car le detail n'est pas dans un stateItems
        const item = context.state.metas[id];
        return actionEnsure(context,types.CATALOGUE_META_DETAIL_REQUEST,buildStateItem(item,item?5:-5),id)
    }
    public [types.CATALOGUE_META_SAVE_REQUEST](context: ActionContext<ICatalogueState, IRootState>,data: AloMeta) {
        return payloadAction(context,types.CATALOGUE_META_SAVE_REQUEST,types.CATALOGUE_META_SAVE_SUCCESS,types.CATALOGUE_META_SAVE_ERROR,apiMeta.saveMeta,data)    
    }
    public [types.CATALOGUE_META_RESET_STATUS](context: ActionContext<ICatalogueState, IRootState>) {
        return new Promise((resolve, reject) => {
            context.commit(types.CATALOGUE_META_RESET_STATUS)
            resolve()
        })
    }
    public [types.CATALOGUE_META_DELETE_REQUEST](context: ActionContext<ICatalogueState, IRootState>,id: number) {
        return payloadAction(context,types.CATALOGUE_META_DELETE_REQUEST,types.CATALOGUE_META_DELETE_SUCCESS,types.CATALOGUE_META_DELETE_ERROR,apiMeta.deleteMeta,id)    
    }
    
    public [types.CATALOGUE_FLUXBUILDER_REQUEST](context: ActionContext<ICatalogueState, IRootState>) {
        return emptyAction(context,types.CATALOGUE_FLUXBUILDER_REQUEST,types.CATALOGUE_FLUXBUILDER_SUCCESS,types.CATALOGUE_FLUXBUILDER_ERROR,apiFluxBuilder.getAllFluxBuilder)    
    }

    public [types.CATALOGUE_FLUXBUILDER_ENSURE](context: ActionContext<ICatalogueState, IRootState>) {
        return actionEnsure(context,types.CATALOGUE_FLUXBUILDER_REQUEST,context.state.fluxBuildersList)    
    }

    public [types.CATALOGUE_FLUXBUILDER_DETAIL_REQUEST](context: ActionContext<ICatalogueState, IRootState>,id:number) {
        return payloadAction(context,types.CATALOGUE_FLUXBUILDER_DETAIL_REQUEST,types.CATALOGUE_FLUXBUILDER_DETAIL_SUCCESS,types.CATALOGUE_FLUXBUILDER_DETAIL_ERROR,apiFluxBuilder.getFluxBuilder,id)
    }

    public [types.CATALOGUE_FLUXBUILDER_DETAIL_ENSURE](context: ActionContext<ICatalogueState, IRootState>,id:number) {
        //Hack car le detail n'est pas dans un stateItems
        const item = context.state.fluxBuilders[id];
        return actionEnsure(context,types.CATALOGUE_FLUXBUILDER_DETAIL_REQUEST,buildStateItem(item,item?5:-5),id)
    }
    public [types.CATALOGUE_FLUXBUILDER_SAVE_REQUEST](context: ActionContext<ICatalogueState, IRootState>,data: AloFluxBuilder) {
        return payloadAction(context,types.CATALOGUE_FLUXBUILDER_SAVE_REQUEST,types.CATALOGUE_FLUXBUILDER_SAVE_SUCCESS,types.CATALOGUE_FLUXBUILDER_SAVE_ERROR,apiFluxBuilder.saveFluxBuilder,data)    
    }
    public [types.CATALOGUE_FLUXBUILDER_RESET_STATUS](context: ActionContext<ICatalogueState, IRootState>) {
        return new Promise((resolve, reject) => {
            context.commit(types.CATALOGUE_FLUXBUILDER_RESET_STATUS)
            resolve()
        })
    }
    public [types.CATALOGUE_FLUXBUILDER_DELETE_REQUEST](context: ActionContext<ICatalogueState, IRootState>,id: number) {
        return payloadAction(context,types.CATALOGUE_FLUXBUILDER_DELETE_REQUEST,types.CATALOGUE_FLUXBUILDER_DELETE_SUCCESS,types.CATALOGUE_FLUXBUILDER_DELETE_ERROR,apiFluxBuilder.deleteFluxBuilder,id)    
    }
}

export default util.classToObject(CatalogueAction)
